export const CREATE_DELIVERY_CHECK_IN_ERROR_TOAST_ID = "create_delivery_check_in_error_toast";
export const OTHER_SUPPLIER_NAME = "Other supplier";
export const REWE_STAGING_ID = "712ac378-865a-4a71-a2d2-f37f01fc5f53";
export const LEKKERLAND_STAGING_ID = "d11664c8-3271-450d-af2c-f64a3407b31a";
export const REWE_SUPPLIER_ID_STAGING = "1019";
export const REWE_SUPPLIER_ID_PROD = "1019";
export const LEKKERLAND_SUPPLIER_ID_STAGING = "4108";
export const LEKKERLAND_SUPPLIER_ID_PROD = "4108";
export const DOUBLE_COUNTER_EQUIPMENT_NAMES_DE = [
  "Rollcontainer/-behälter",
  "Rot/Red TKTs",
  "Blau/Blue TKTs",
];
export const DOUBLE_COUNTER_EQUIPMENT_NAMES_NL = ["Roll Container Lekkerland"];
export const REWE_PROD_ID = "330c377c-4224-43a5-9e14-198f1fc3d1c2";
export const LEKKERLAND_PROD_ID = "13695079-9986-4a41-b88b-18e668c1c712";
export const SUPPLIERS_WITH_ROLLIES = [
  REWE_STAGING_ID,
  LEKKERLAND_STAGING_ID,
  REWE_PROD_ID,
  LEKKERLAND_PROD_ID,
];
